import React, { useEffect } from 'react';
import {
  HeadingText,
  ParagraphText,
  Modal,
  useMediaQuery,
  queryHelpers,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { ANALYTICS_SCREEN_NAMES } from '@telus-alberta-health-web/shared-module';
import {
  EVENT_NAME,
  PRODUCT_AREA,
  SUB_PRODUCT_AREA,
  trackAnalyticsEvent,
} from '@leagueplatform/analytics';
import { BaseModalContainer } from './common/base-modal.component';
import { ModalActionButton } from './common/modal-action-button.component';

export const GenderIdentityTooltip = () => {
  const { formatMessage } = useIntl();

  useEffect(() => {
    trackAnalyticsEvent(EVENT_NAME.SCREEN_LOADED, {
      product_area: PRODUCT_AREA.SETTINGS,
      sub_product_area: SUB_PRODUCT_AREA.PERSONAL_INFO,
      screen_name: ANALYTICS_SCREEN_NAMES.SEX_AND_GENDER_IDENTITY_INFO,
    });
  }, []);

  const isMobile = useMediaQuery(queryHelpers.only('mobile'));

  return (
    <BaseModalContainer
      footer={
        <ModalActionButton
          actionType="submit"
          buttonText={formatMessage({ id: 'STR_CLOSE' })}
          isMobile={isMobile}
          data-testid="submit-button"
          css={{
            background: '$interactiveActionPrimary',
            alignSelf: 'flex-end',
            marginBlockStart: '$two',
          }}
        />
      }
    >
      <Modal.Title>
        <HeadingText level="3" size="md">
          {formatMessage({ id: 'STR_WHY_YOU_ASK_HEADING' })}
        </HeadingText>
      </Modal.Title>
      <ParagraphText size="sm">
        {formatMessage({ id: 'STR_WHY_YOU_ASK_HEADING_BODY_1' })}
      </ParagraphText>
      <ParagraphText size="sm">
        {formatMessage({ id: 'STR_WHY_YOU_ASK_HEADING_BODY_2' })}
      </ParagraphText>
    </BaseModalContainer>
  );
};
